<dx-popup class="popup" [width]="300" [maxHeight]="'82vh'"
          [height]="'auto'" [showTitle]="false" [dragEnabled]="true"
          [closeOnOutsideClick]="false" [showCloseButton]="false" [(visible)]="popupVisible" (onShown)="onShown()">
    <dxi-toolbar-item location="before">
        <h4 fxShow style="margin: 5px 0">
            Settings
        </h4>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="before">
        <dx-load-indicator
            height="20"
            width="20"
            [(visible)]="isLoading"
            style="margin-left: 8px; margin-top: 4px;"
        ></dx-load-indicator>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button text="Close" (click)="close()"></dx-button>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button text="Save" (click)="submit()"></dx-button>
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'" style="height: 100%;">
        <dx-scroll-view [showScrollbar]="'onScroll'">
            <form [formGroup]="userForm" style="height: 100%;">
                <div fxLayout="column" fxFlex="100%">
                    <div id="form" fxLayout="row" fxLayoutAlign="center">
                        <div class="ocl-dialog-content" fxLayout="column" fxLayoutAlign="space-between start"
                             style="padding-right: 16px; padding-left: 16px">
                            <div class="dx-field">
                                <div class="dx-field-label">Email <span class="ocl-required-indicator">*</span></div>
                                <div class="dx-field-value">
                                    <dx-text-box formControlName="email" [disabled]="true">
                                        <dx-validator>
                                            <dxi-validation-rule type="required"
                                                                 message="Email is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">Last Name <span class="ocl-required-indicator">*</span>
                                </div>
                                <div class="dx-field-value">
                                    <dx-text-box formControlName="lastName">
                                        <dx-validator validationGroup="userProfileGroup">
                                            <dxi-validation-rule type="required"
                                                                 message="Last Name is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">First Name <span class="ocl-required-indicator">*</span>
                                </div>
                                <div class="dx-field-value">
                                    <dx-text-box formControlName="firstName">
                                        <dx-validator validationGroup="userProfileGroup">
                                            <dxi-validation-rule type="required"
                                                                 message="First Name is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">Old Password <span class="ocl-required-indicator">*</span>
                                </div>
                                <div class="dx-field-value">
                                    <dx-text-box formControlName="oldPassword" mode="password">
                                        <dx-validator validationGroup="userProfileGroup">
                                            <dxi-validation-rule type="required"
                                                                 message="Old Password is required"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                            <div class="dx-field">
                                <div class="dx-field-label">New Password <span class="ocl-required-indicator">*</span>
                                </div>
                                <div class="dx-field-value">
                                    <dx-text-box formControlName="newPassword" value="password" [(mode)]="passwordMode">
                                        <dxi-button name="today" location="after"
                                                    [options]="passwordButton"></dxi-button>
                                        <dx-validator validationGroup="userProfileGroup">
                                            <dxi-validation-rule type="required"
                                                                 message="New Password is required"></dxi-validation-rule>
                                            <dxi-validation-rule type="pattern" [pattern]="passwordPattern"
                                                                 message="The new password is invalid"></dxi-validation-rule>
                                        </dx-validator>
                                    </dx-text-box>
                                </div>
                            </div>
                            <div class="dx-field">
                              <app-theme-toggle></app-theme-toggle>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </dx-scroll-view>
    </div>
</dx-popup>
<dx-load-panel
    shadingColor="rgba(0,0,0,0.4)"
    [(visible)]="isLoading"
    [showIndicator]="true"
    [showPane]="true"
    [shading]="true"
    [closeOnOutsideClick]="false">
</dx-load-panel>

